import React from 'react';
import PropTypes from 'prop-types';

function Frame() {
  return (
    <svg
      width="410"
      height="435"
      viewBox="0 0 410 435"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.97677 178.933V434.762H400.118V178.933H9.94238H9.97677Z"
        fill="#216BDA"
      />
      <g filter="url(#filter0_f_684_1454)">
        <path
          d="M55.0772 162.731C16.9687 162.731 7.16235 161.939 7.16235 165.825V184.584H401.991V165.825C401.991 161.156 391.68 162.731 354.076 162.731H55.0839H55.0772Z"
          fill="black"
        />
      </g>
      <path
        d="M50.5265 92.1085C11.1362 92.1085 1 88.9426 1 104.461V179.374H409.108V104.461C409.108 85.8159 398.451 92.1085 359.582 92.1085H50.5333H50.5265Z"
        fill="#4696F4"
      />
      <path
        d="M169.389 92.103V179.434H240.889V92.103H169.389Z"
        fill="#EEEEEE"
      />
      <path
        d="M233.809 183.879L176.569 184.153V267.455H233.809V183.879Z"
        fill="#EEEEEE"
      />
      <path
        d="M176.569 434.759H233.809V352.955H176.569V434.759Z"
        fill="#EEEEEE"
      />
      <path
        d="M104.657 0C104.159 0.000228405 103.692 0.0161616 103.199 0.0443315C100.832 0.177263 98.5449 0.64854 96.3969 1.54826C88.6453 4.79511 81.84 11.7278 78.6359 19.5511C71.9756 35.8121 71.9598 56.067 78.6359 72.3218C81.8418 80.1267 86.5399 90.2364 96.3969 90.2364H160.91C170.768 90.2364 178.726 82.2628 178.726 72.3218C178.726 72.3218 181.577 47.3693 175.379 37.554C162.822 17.6691 137.571 7.77458 115.023 1.54826C111.751 0.644977 108.14 -0.00158203 104.657 9.29382e-05L104.657 0ZM304.511 0.0443315C301.323 0.137673 298.055 0.722391 295.064 1.54826C272.515 7.77397 247.263 17.6691 234.707 37.554C228.509 47.3692 231.36 72.3218 231.36 72.3218C231.36 82.2626 239.318 90.2364 249.176 90.2364H313.69C323.547 90.2364 328.245 80.1269 331.451 72.3218C338.127 56.0685 338.111 35.8121 331.451 19.5511C328.246 11.7277 321.441 4.79511 313.69 1.54826C310.826 0.34866 307.7 -0.0490404 304.512 0.0443315H304.511ZM121.868 25.3455C124.259 25.3444 126.694 25.7699 128.94 26.3629C144.42 30.4495 161.781 36.9306 170.402 49.983C174.657 56.4257 172.669 72.8067 172.669 72.8067C172.669 79.3319 167.236 84.5728 160.469 84.5728H116.2C109.432 84.5728 106.2 77.9298 103.999 72.8067C99.4158 62.1377 99.4266 48.8455 103.999 38.1714C106.199 33.0361 110.878 28.4924 116.2 26.3612C117.675 25.7706 119.218 25.4752 120.843 25.388C121.181 25.3695 121.527 25.3439 121.869 25.3437L121.868 25.3455ZM288.2 25.3455C288.542 25.3456 288.887 25.3711 289.226 25.3898C290.851 25.4769 292.394 25.7724 293.869 26.363C299.19 28.4943 303.869 33.0379 306.069 38.1732C310.642 48.8465 310.653 62.1389 306.069 72.8085C303.868 77.9317 300.636 84.5745 293.869 84.5745H249.6C242.832 84.5745 237.399 79.3337 237.399 72.8085C237.399 72.8085 235.411 56.4272 239.666 49.9847C248.287 36.9318 265.593 30.45 281.073 26.3646C283.319 25.7717 285.809 25.3461 288.2 25.3472L288.2 25.3455ZM182.388 41.314C188.586 50.4347 185.789 73.6044 185.789 73.6044C185.789 78.5117 183.584 82.9053 180.012 85.9455C182.268 88.5764 185.67 90.2362 189.568 90.2362H220.449C224.362 90.2362 227.858 88.595 230.112 85.9455C226.541 82.9051 224.282 78.5117 224.282 73.6044C224.282 73.6044 221.431 50.435 227.629 41.314C219.181 28.1357 191.643 27.6655 182.388 41.314H182.388Z"
        fill="#87D6F8"
      />
      <defs>
        <filter
          id="filter0_f_684_1454"
          x="0.72285"
          y="156.036"
          width="407.707"
          height="34.9879"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="3.21975"
            result="effect1_foregroundBlur_684_1454"
          />
        </filter>
      </defs>
    </svg>
  );
}

Frame.propTypes = {
  color: PropTypes.string,
};

Frame.defaultProps = {
  color: '#000000',
};

export default Frame;
